import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext.jsx";
import { apiFetch } from "../lib/api.js";
import PremiumLock, { usePaid } from "../components/PremiumLock.jsx";

function download(path) {
  window.open(`/api${path}`, "_blank");
}

export default function Exports() {
  const isPaid = usePaid();
  const [hasReport, setHasReport] = useState(null);

  useEffect(() => {
    if (!isPaid) return;
    apiFetch("/insight/report")
      .then((r) => setHasReport(!!r.latest))
      .catch(() => setHasReport(false));
  }, [isPaid]);

  return (
    <div className="page">
      <div className="kicker" style={{ marginBottom: 12 }}>
        <span className="the-line" />
        EXPORTS
      </div>
      <h1 style={{ marginBottom: 32 }}>Take it with you</h1>

      {!isPaid && (
        <PremiumLock title="Field reports and full data export">
          Export a PDF field report of your Standing Check, a PDF of your floor, and a full
          structured export of your member file, diagnostics and sessions. Available on
          Conquest Premium - coming soon.
        </PremiumLock>
      )}

      {isPaid && (
        <div className="card-grid" style={{ gridTemplateColumns: "1fr" }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div className="card-title" style={{ marginBottom: 4 }}>Standing Check field report</div>
              <div style={{ color: "var(--muted)", fontSize: 14 }}>PDF of your latest result and domain scores.</div>
            </div>
            <button className="btn-secondary" onClick={() => download("/exports/diagnostic-field-report")}>
              Download PDF
            </button>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div className="card-title" style={{ marginBottom: 4 }}>The Floor</div>
              <div style={{ color: "var(--muted)", fontSize: 14 }}>PDF of your minimum viable week.</div>
            </div>
            <button className="btn-secondary" onClick={() => download("/exports/floor")}>
              Download PDF
            </button>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div className="card-title" style={{ marginBottom: 4 }}>Full data export</div>
              <div style={{ color: "var(--muted)", fontSize: 14 }}>
                Member file, diagnostics history and sessions as structured JSON.
              </div>
            </div>
            <button className="btn-secondary" onClick={() => download("/exports/data.json")}>
              Download JSON
            </button>
          </div>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div>
              <div className="card-title" style={{ marginBottom: 4 }}>AI insight report</div>
              <div style={{ color: "var(--muted)", fontSize: 14 }}>
                {hasReport === false
                  ? "Generate a report on the Insight page first, then it will be downloadable here."
                  : "PDF of your latest AI-authored insight report."}
              </div>
            </div>
            <button
              className="btn-secondary"
              onClick={() => download("/exports/insight-report")}
              disabled={hasReport === false}
            >
              Download PDF
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
